export const ADMIN_ROUTE_META = [
  {
    key: "dashboard",
    segment: "",
    path: "/admin",
    icon: "iconChartLineUp",
    labelKey: "commons.labels.dashboard",
  },
  {
    key: "circuits",
    segment: "circuits",
    path: "/admin/circuits",
    icon: "iconLineSegments",
    labelKey: "tripPublication.trips",
  },
  {
    key: "reservations",
    segment: "reservations",
    path: "/admin/reservations",
    icon: "iconCalendar",
    labelKey: "tripReservation.tripReservation",
  },
  {
    key: "inbox",
    segment: "inbox",
    path: "/admin/inbox",
    icon: "iconEnvelope",
    labelKey: "inbox.title",
  },
  {
    key: "organisme",
    segment: "organisme",
    path: "/admin/organisme",
    icon: "iconBank",
    labelKey: "organism.label",
  },
  {
    key: "establishments",
    segment: "establishments",
    path: "/admin/establishments",
    icon: "iconBuildings",
    labelKey: "manageEstablishment.establishments",
  },
  {
    key: "establishmentNewAdd",
    segment: "establishments/add",
    path: "/admin/establishments/add",
    icon: "iconPlus",
    labelKey: "manageEstablishment.new.menu.add",
  },
  {
    key: "utilisateurs",
    segment: "utilisateurs",
    path: "/admin/utilisateurs",
    icon: "iconUsers",
    labelKey: "manageUsers.users",
  },
];

const normalizePathname = (pathname = "") => pathname.replace(/\/+$/, "");

export const isAdminRouteActive = (pathname = "", segment = "") => {
  const normalizedPath = normalizePathname(pathname);

  if (!segment) {
    return normalizedPath === "/admin";
  }

  return (
    normalizedPath === `/admin/${segment}` ||
    normalizedPath.startsWith(`/admin/${segment}/`)
  );
};

export const getActiveAdminRouteMeta = (pathname = "") =>
  ADMIN_ROUTE_META.find((route) => isAdminRouteActive(pathname, route.segment)) ||
  ADMIN_ROUTE_META[0];
